/**图标*/
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
/**控件语言*/
import locale from "element-plus/es/locale/lang/zh-cn";

/**去除浏览器默认样式方法*/
import "@/assets/style/reset.css";
/**全局css */
import "@/assets/style/pages.css";

import store from "@/store";

import clientStorage from "@/utils/storage";
import constant from "@/config/constant";
import prompt from "@/utils/prompt";

import App from "@/App.vue";
import router from "@/router";

import { createApp, reactive } from "vue";

/**创建vue实例*/
const app = createApp(App);

/**读取图标（全局）*/
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

/**ElementPlus.Dialog.props.closeOnClickModal.default = false*/

app.use(store);
app.use(router);
app.use(ElementPlus, { locale, size: "small", zIndex: 3000 });

/**全局变量*/
app.config.globalProperties.$storage = clientStorage;
app.config.globalProperties.$constant = constant;
app.config.globalProperties.$prompt = prompt;

/**根据不同的分辨率，设置抽屉的宽度 */
app.config.globalProperties.$drawerWidth = () => {
  let width = "100%";
  if (window.innerWidth > 500) {
    width = "90%";
  }
  return width;
};

app.config.globalProperties.$drawerMoreWidth = () => {
  let width = "100%";
  if (window.innerWidth > 500) {
    width = "500px";
  }
  return width;
};

/**判断移动还是电脑 */
app.config.globalProperties.$isMobile = () => {
  /**
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
   */
  const isMobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return isMobile;
};

/**全局变量-判断打开页面 */
const globalVars = reactive({
  openNodeTime: "1",
});
app.provide("globalVars", globalVars);

/**挂载实例*/
app.mount("#app");

/**网页不能回退-2*/
window.addEventListener("popstate", function () {
  history.pushState({}, "", document.URL);
});

/**防止localStoragesessionStorage被修改*/
window.addEventListener("storage", function (e: any) {
  if (e) {
    localStorage.setItem(e.key, e.oldValue);
  } else {
    /**window.localStorage.clear();*/
  }
});
